var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.987 32.744c.788.788.8 2.055.013 2.841a1.994 1.994 0 0 1-2.836-.008l-12.57-12.57a2 2 0 0 1 0-2.844l12.57-12.57A2.001 2.001 0 0 1 20 7.586a2.002 2.002 0 0 1-.013 2.842l-9.158 9.158h27.166c1.108 0 2.005.888 2.005 2 0 1.105-.905 2-2.005 2H10.83l9.158 9.159z"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 44 44"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
